import { FieldValues } from "react-hook-form";

import { currencyMask } from "@/utils/string";

import { VnText } from "./VnText/VnText";
import { VnTextInput, VnTextInputPropsType } from "./VnTextInput/VnTextInput";

export const VnCurrencyInput = <T extends FieldValues>({
  ...props
}: VnTextInputPropsType<T>) => {
  return (
    <VnTextInput
      {...props}
      placeholder="0"
      keyboardType="number-pad"
      mask={{ maskGenerator: currencyMask }}
      leftElement={<VnText className="text-muted-foreground">$</VnText>}
    />
  );
};
